import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private toggle_sidebar = new BehaviorSubject<boolean>(false);
  private toggle_left_sidebar = new BehaviorSubject<boolean>(false);
  private toggle_layout_overlay = new BehaviorSubject<boolean>(false);
  toggle_sidebar_data: any;
  toggle_sidebar$ = this.toggle_sidebar.asObservable();
  toggle_left_sidebar$ = this.toggle_left_sidebar.asObservable();
  toggle_layout_overlay$ = this.toggle_layout_overlay.asObservable();

  constructor(private router: Router) {
    this.toggle_layout_overlay$.pipe(takeUntilDestroyed()).subscribe((res: boolean) => {
      if (res) {
        document.body.classList.add('hidden');
      } else {
        document.body.classList.remove('hidden');
      }
    });
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.toggleLayoutSidebar(false);
      }
    });
  }

  toggleLayoutSidebar(state: boolean) {
    this.toggle_sidebar.next(state);
  }

  // Method to toggle the left sidebar
  toggleLeftLayoutSidebar(state: boolean) {
    this.toggle_left_sidebar.next(state);
  }

  // Method to toggle the layout overlay
  toggleLayoutOverlay(state: boolean) {
    this.toggle_layout_overlay.next(state);
  }
}
